import { jsx } from "react/jsx-runtime";
import { BlockElement } from "../../../baseEditor/BlockElement.js";
const ListItemRenderer = (props) => /* @__PURE__ */ jsx(BlockElement, { ...props, domElement: "li", children: props.children });
ListItemRenderer.displayName = "ListItemRenderer";
export {
  ListItemRenderer
};
//# sourceMappingURL=ListItemRenderer.js.map
